/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  TriggerService,
  ITriggerMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  TriggerCycloneService,
  ITriggerCycloneMethods,
} from "./components";

export type TriggerAgent = IHeaderMethods &
  IFooterMethods &
  ITriggerMethods &
  ITriggerCycloneMethods &
  IStaticPageContentMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FooterService(),
    new TriggerService(),
    new StaticPageContentService(),
    new TriggerCycloneService(),
  ];
};

export const getAgent = () => {
  return createAgent<TriggerAgent>({
    plugins: getPlugins(),
  });
};
